<template>
    <v-row>
        <v-col cols="12">
            <TableV nombre="Usuarios de la Aplicación" :table="user" :type="type" :headerss="header" :loadings="loading" />
        </v-col>
    </v-row>    
</template>
<script>

import Table from '../../../../../component/helpers/tools/table'
import Single from '../../../../../component/helpers/tools/single'
import TableV from '../../../../../component/helpers/tools/tablesearchVehiculo'

export default {
    
    components:{
        Table,
        Single,
        TableV
    },

    data() {
        return {
            type:'usuariosapp',
            header: [
                {
                    text: 'Usuario Aplicacion',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Responsabilidad (Coordinador)', align: 'right', value: 'user.name' },
                { text: 'Estado', align: 'right', value: 'status' },
                
                
                
                
            ]
        }
    },

    computed: {
    
        user(){
            return this.$store.state.users_app;
        },

        loading(){
            return this.$store.state.loading_dashboard
        },


    },

}
</script>